"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildOrganizationModel = void 0;
var models_1 = require("./models");
function buildOrganizationModel(organizationJSON) {
    return new models_1.OrganisationModel(organizationJSON.id, organizationJSON.name, organizationJSON.feature_analytics, organizationJSON.stop_serving_flags, organizationJSON.persist_trait_data);
}
exports.buildOrganizationModel = buildOrganizationModel;
